import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { AuthenticationRoutingModule } from './authentication-routing.module';
import { SignInComponent } from './sign-in/sign-in.component';
import { SignUpComponent } from './sign-up/sign-up.component';

// primeng imports
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { ImageModule } from 'primeng/image';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { TranslateModule } from '@ngx-translate/core';
import { LetDirective } from '@ngrx/component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
    declarations: [SignInComponent, ResetPasswordComponent, SignUpComponent],
    imports: [CommonModule, AuthenticationRoutingModule, InputTextModule, ButtonModule, ReactiveFormsModule, ImageModule, LetDirective, TranslateModule, SharedModule],
    exports: [SignInComponent]
})
export class AuthenticationModule {}
